import React, {Component} from 'react';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import DataGrid from '../../react-data-grid/dist/react-data-grid.min.js';
import {Editors, Formatters} from '../../react-data-grid-addons/dist/react-data-grid-addons.min.js';
import DialogStyles from '../ModalDialog/DialogStyles'
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import objeler from '../objeler.js';
import {withAlert} from '../../react-alert-master/src'

const {DropDownEditor, CheckboxEditor} = Editors;
const {DropDownFormatter} = Formatters;
const titleTypes = [
    {id: 'String', value: 'String', text: 'String', title: 'String'},
    {id: 'Integer', value: 'Integer', text: 'Integer', title: 'Integer'},
    {id: 'DateTime', value: 'DateTime', text: 'DateTime', title: 'DateTime'},
];
const TitleTypesEditor = <DropDownEditor options={titleTypes} style={{fontSize: '10px'}}
/>;
const TitleTypesFormatter = <DropDownFormatter options={titleTypes} style={{fontSize: '10px'}}/>;
const formatStyle = {
    display: "block",
    marginLeft: 0,
    width: "460px",
    height: "200px",
    zIndex: "0",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial'
    , overflow: 'hidden'
};
const tbStyle = {
    display: "block",
    marginLeft: 0,
    width: "80px",
    height: "22px",
    zIndex: "0",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial'
    , overflow: 'hidden'
    , textTransform: 'uppercase'
};
const comboStyle = {
    display: "block",
    width: "100%",
    height: "25px",
    zIndex: "0",
    vAlign: "middle",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial'
    , overflow: 'hidden'
};
const dataTypeItems = {
    "values": [
        {"name": "String", "value": "String"},
        {"name": "Integer", "value": "Integer"}
    ]
}
const columns = [
    {
        key: 'Name', name: 'Name', editable: true, width: 120, height: 23, draggable: false
    },
    {
        key: 'DataType', name: 'Data Type', editable: true, editor: TitleTypesEditor, formatter: TitleTypesFormatter,
        width: 110, height: 23, draggable: false
    }
];
const rows = [
    {Name: 'ID', DataType: 'System.Int32'}
];

class Datasource extends Component {
    constructor(props) {
        super(props);
        this.state = {dsTab: this.props.data, tabValue: 0, selectedIndexes: [], update: true};
        this.child = React.createRef();
        objeler["dsClass"] = this;
    };

    componentWillMount() {
        this.setState({update: true});
    }

    componentWillUpdate() {
        if (this.state.update) {
            this.setState({dsTab: this.props.data, update: false});
        }
    }

    setDataSource(e) {
        this.setState({dsTab: e});
        objeler.ModalDocValues.DataSource = e;
    }

    clearDataSource() {
        this.setState({dsTab: []});
    }

    componentDidMount() {
        this.setFocus();
    }

    setFocus() {
        setTimeout(() => {
            try {
                this.child.select();
            } catch {
                try {
                    this.child.focus();
                } catch {
                }
            }
        }, 1);
    }

    onChangeDataType() {
    }

    handleChange = (e) => {
        this.clearLastRow();
        this.setState({tabValue: e});
        console.log('fff ', e)
        this.setFocus();
    };

    queryOnChage(e, id) {
        this.change(e.target.value, id)
    }

    titleOnChage(e, id) {
        const dsTab = this.state.dsTab;
        var stop = false;
        var changeTitle = false;
        if (e.target.value.length < 1) {
            stop = true;
        }
        for (let t in dsTab) {
            console.log('KKK', e.target.value, dsTab[t].title)
            if (t != id && e.target.value == dsTab[t].title) {
                stop = true;
                break;
            }
        }
        if (stop) {
            e.stopPropagation();
            e.preventDefault();
            if (changeTitle)
                e.target.value = dsTab[id].title;
            return false;
        }
        console.log('cer', e.target.value, id)
        dsTab[id].title = e.target.value;
        this.setState({dsTab: dsTab});
    }

    change(e, id) {
        const dsTab = this.state.dsTab;
        dsTab[id].query = e;
        console.log('fff ', e)
        var str = e;
        let str2 = '<h1>Hello, world!</h1>';
        str2 = str;
        let regexp = /{(.*?)}/g;
        let keys = [];
        let keysRow = [];
        let matchAll = str2.matchAll(regexp);
        console.log('ggg', matchAll)
        matchAll = Array.from(matchAll);
        for (let prp in matchAll) {
            console.log(matchAll[prp][1])
            for (let tb in dsTab[0].rows) {
                if (dsTab[0].rows[tb].Name == matchAll[prp][1]) {
                    if (!keys.includes(tb)) {
                        keys.push(tb);
                    }
                }
            }
        }
        console.log('RR', keys.join())
        dsTab[id].keys = keys.join();
        dsTab[id].rows = []
        for (let i in keys) {
            dsTab[id].rows = [...dsTab[id].rows, dsTab[0].rows[keys[i]]]
        }
        console.log('CE', ...dsTab[0].rows)
        console.log('CE', ...dsTab[id].rows)
        this.setState({dsTab: dsTab});
    }

    clearLastRow() {
        const dsTab = this.state.dsTab;
        console.log('last', dsTab[0].rows[dsTab[0].rows.length - 1])
        try {
            if (dsTab[0].rows[dsTab[0].rows.length - 1].Name === "")
                dsTab[0].rows.pop();
        } catch {
        }
    }

    onGridRowsUpdated(e, i) {
        console.log('ROWS', e.fromRow, e.toRow, e.updated)
        const dsTab = this.state.dsTab;
        const rows = dsTab[i].rows.slice();
        for (let t = e.fromRow; t <= e.toRow; t++) {
            dsTab[i].rows[t] = {...dsTab[i].rows[t], ...e.updated};
        }
        this.setState({dsTab: dsTab});
        if (i == 0) {
            for (let t = 1; t < dsTab.length; t++) {
                console.log('iiii', dsTab)
                this.change(dsTab[t].query, t);
            }
        }
    };

    addRow(i) {
        console.log('İİ ', this.state.tabValue)
        const dsTab = this.state.dsTab;
        for (let prp in dsTab[this.state.tabValue].rows) {
            if (dsTab[this.state.tabValue].rows[prp].Name === "") return;
        }
        dsTab[this.state.tabValue].rows.push({Name: '', DataType: 'Integer'})
        this.setState({dsTab: dsTab});
        console.log('İİ ', this.state.dsTab)
    }

    addTab(i) {
        this.clearLastRow();
        console.log(' state dsTab.length ', this.state.dsTab.length);
        const dsTab = this.state.dsTab;
        var tt = {
            id: dsTab.length,
            title: 'DETAIL' + dsTab.length,
            query: "",
            keys: "",
            rows: []
        }
        dsTab.push(tt);
        console.log(' dsTab.length ', dsTab.length);
        this.setState({dsTab: dsTab, tabValue: dsTab.length - 1});
        console.log('İİ ', this.state.tabValue)
        this.setFocus();
    }

    removeTab(i) {
        const {alert} = objeler.Editor.props;
        alert.success("Are you sure you want to remove it?", true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.removeTabOK(i)
                        },
                    }
                ]
            }
        );
    }

    removeTabOK(i) {
        if (this.state.tabValue < 1) return;
        console.log('current', i);
        const dsTab = this.state.dsTab;
        var tt = {
            id: dsTab.length,
            title: 'DETAIL' + dsTab.length,
            query: "",
            rows: []
        }
        dsTab.splice(this.state.tabValue, 1);
        for (let prp in dsTab) {
            dsTab[prp].id = prp;
        }
        console.log(' dsTab.length ', dsTab.length);
        this.setState({dsTab: dsTab, tabValue: dsTab.length - 1});
        console.log('sil ', this.state.dsTab)
        this.setFocus();
    }

    onRowsSelected = (rows) => {
        this.setState({selectedIndexes: this.state.selectedIndexes.concat(rows.map(r => r.rowIdx))});
        let rowIndexes = rows.map(r => r.rowIdx);
        let totalSelected = rowIndexes.length + this.state.selectedIndexes.length;
    };
    onRowsDeselected = (rows) => {
        console.log('RM', rows)
        console.log('RM', rows.map(r => r.rowIdx))
        var items = this.state.selectedIndexes.filter((i) => (rows.map(r => r.rowIdx).indexOf(i) === -1))
        this.setState({selectedIndexes: items});
        console.log('items', items)
        let rowIndexes = rows.map(r => r.rowIdx);
        let totalSelected = rowIndexes.length + this.state.selectedIndexes.length;
    };

    render() {
        const {classes} = this.props;
        if (this.state.dsTab == undefined)
            return false;
        return (
            <React.Fragment>
                {
                    this.state.dsTab.length > 0 &&
                    <Tabs onSelect={e => {
                        this.handleChange(e)
                    }}
                          selectedIndex={this.state.tabValue}
                    >
                        <TabList>
                            {this.state.dsTab.map((item, i) => {
                                return (<Tab
                                    >{item.title}</Tab>
                                );
                            })}
                        </TabList>
                        {this.state.dsTab.map((item, i) => {
                            return (
                                <TabPanel style={{height: 200}}>
                                    <table style={{height: 100}}>
                                        <tr style={{height: '29px', paddingTop: '0px'}}>
                                            <td style={{verticalAlign: 'top', marginTop: '0px'}}>
                                                <div style={{whiteSpace: 'nowrap', display: 'inline-flex'}}>
                                                    <input name="TextArea1" id="TextArea1"
                                                           ref={abc => this.child = abc}
                                                           value={this.state.dsTab[item.id].title}
                                                           onChange={e => this.titleOnChage(e, item.id)}
                                                           style={tbStyle} rows="1" cols="20" spellCheck="false"
                                                           minlength="6"
                                                           maxlength="8"
                                                           onKeyDown={event => {
                                                               if (!(
                                                                   (event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || (event.keyCode >= 48 && event.keyCode <= 57)
                                                               ) && event.keyCode != 8 && !(event.keyCode >= 37 && event.keyCode <= 40))
                                                                   event.preventDefault();
                                                           }}
                                                    >
                                                    </input>
                                                    &nbsp;&nbsp;&nbsp;
                                                    Query
                                                </div>
                                            </td>
                                            <td style={{verticalAlign: 'top', marginTop: '0px'}}>
                                                <h2>{item.id == 0 ? '' : 'Bind '}Fields</h2>
                                            </td>
                                            <td style={{verticalAlign: 'top', marginTop: '0px'}}>
                                                {this.state.tabValue == 0 &&
                                                    <Button autoFocus
                                                            onClick={e => {
                                                                this.addRow(e)
                                                            }}
                                                            disableRipple={true}
                                                            disableTouchRipple={true}
                                                            focusRipple={false}
                                                            className={classes.closeButton}
                                                            style={{width: '50px', padding: '3px 0px', top: '-7px'}}
                                                    >
                                                        Add
                                                    </Button>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{verticalAlign: 'top'}}>
                                                <textarea name="TextArea1" id="TextArea1"
                                                          ref={abc => this.child = abc}
                                                          value={this.state.dsTab[item.id].query}
                                                          onChange={e => this.queryOnChage(e, item.id)}
                                                          style={formatStyle} rows="1" cols="20" spellCheck="false">
                                                </textarea>
                                            </td>
                                            <td style={{width: 250}} colSpan='2'>
                                                <DataGrid columns={columns}
                                                          rowGetter={i => this.state.dsTab[item.id].rows[i]}
                                                          rowsCount={this.state.dsTab[item.id].rows.length}
                                                          rowHeight={23}
                                                          enableCellSelect={true}
                                                          disableCellDrag={true}
                                                          onGridRowsUpdated={e => this.onGridRowsUpdated(e, i)}
                                                          style={{overflow: 'hidden', height: '50px'}}
                                                          height={150}
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </TabPanel>
                            );
                        })}
                        <table style={{
                            width: '460px',
                            display: 'inline-block',
                            top: '282px',
                            position: 'absolute',
                        }}>
                            <row
                            >
                                <td
                                    align='left' style={{width: '285px'}}
                                >
                                    {this.state.dsTab.length < 7 && <Button autoFocus
                                                                            onClick={e => {
                                                                                this.addTab(e)
                                                                            }}
                                                                            disableRipple={true}
                                                                            disableTouchRipple={true}
                                                                            focusRipple={false}
                                                                            className={classes.closeButton}
                                                                            style={{
                                                                                width: '130px',
                                                                                padding: '6px 0px 6px 0px'
                                                                            }}
                                    >
                                        Add
                                    </Button>
                                    }
                                </td>
                                <td
                                    align='right' style={{width: '185px'}}
                                >
                                    {this.state.tabValue > 0 && <Button autoFocus
                                                                        onClick={e => {
                                                                            this.removeTab(e)
                                                                        }}
                                                                        disableRipple={true}
                                                                        disableTouchRipple={true}
                                                                        focusRipple={false}
                                                                        className={classes.closeButton}
                                                                        style={{
                                                                            width: '130px',
                                                                            padding: '6px 0px 6px 0px'
                                                                        }}
                                    >
                                        Remove
                                    </Button>
                                    }
                                </td>
                            </row>
                        </table>
                    </Tabs>
                }
            </React.Fragment>
        );
    }
}

export default withAlert()(withStyles(DialogStyles)(Datasource));